import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import queryString from 'query-string';
import { ConnectedRouter } from 'connected-react-router';
import { QueryClient, QueryClientProvider } from "react-query";
import request from '@utils/request';
import { awaitWrapper } from 'utils/helper';

import configureStore from '@utils/configureStore';
import history from '@utils/history';
import App from './App';

const boot = (user = {}) => {
  const initialState = {
    global: {
      user,
      userList: [],
      productList: [],
    },
  };
  const store = configureStore(initialState, history);
  const MOUNT_NODE = document.getElementById('root');
  const queryClient = new QueryClient();

  const render = () => {
    ReactDOM.render(
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <ConnectedRouter history={history}>
            <App />
          </ConnectedRouter>
        </QueryClientProvider>
      </Provider>,
      MOUNT_NODE,
    );
  };

  if (module.hot) {
    module.hot.accept(['./App'], () => {
      ReactDOM.unmountComponentAtNode(MOUNT_NODE);
      render();
    });
  }
  render();
};

const init = async () => {
  if (window.location.search.indexOf('?nekot=') > -1) {
    let params = queryString.parse(window.location.search)
    const qToken = params.nekot;
    localStorage.setItem('token', qToken);
    window.location.replace('/');
  }
  const token = localStorage.getItem('token');
  let user = {};
  if (token) {
    const [err, res] = await awaitWrapper(request.get('v1/users/current'));
    if (!err) {
      user = res.data;
    }
  }
  boot(user);
};

init();
